<template>
    <v-flex xl12>
        <h2>Avaliações<span class="text-title-header"> | Resumo</span></h2>
        <v-divider></v-divider>
        <br/>
        <router-view></router-view>
    </v-flex>
</template>
<script>
export default {
  name: 'rantings',
  mounted: function () {
    this.$nextTick(function () {

    })
  }
}
</script>
